<template>
    <div>
        <section class="container-fluid top">
            <div class="row more-top" data-aos="fade-up">
                <div class="col-12 ">
                    <div class="row d-none d-md-flex"  v-if="false">
                        <div class="col-12 p-5" >
                            <h3 class="title-subtitle text-center bold">{{$store.state.lang == 'es' ? categoria.col_description_es : categoria.col_description_en}}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       
        <section class="container d-md-none">
            <div class="row" data-aos="fade-up">
                <div class="col-12 image-pad" >
                    <Transition  name="fade" appear>
                        <div class="row">
                            <div class="col-12  pb-5 mb-5" v-for="(item,x) in items" :key="x" >
                                <carousel :item="item"></carousel>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
        </section>

        <section class="d-none d-md-block pb-5 mb-5">
            <div data-aos="fade-up" style="padding: 0 1rem">
                <Transition name="fade" appear>
                    <masonry :items="masonry" @show-image="openViewer"></masonry>
                </Transition>
            </div>
        </section>

         <!-- Bootstrap Modal with ImageViewer -->
         <ImageViewer 
            v-if="showViewer"
            :item="selectedItem" 
            @close="closeViewer"
        />
    </div>
</template>

<script>
import axios from 'axios'
import 'viewerjs/dist/viewer.css'
import { component as Viewer } from "v-viewer"
import carousel from '@/components/Carousel.vue'
import masonry from '@/components/Masonry.vue'
import ImageViewer from '@/components/ImageViewer.vue'

export default {
    name: 'OilCollectionComponent',
    components:{Viewer,carousel,masonry,ImageViewer},
    data(){
        return{         
            items:{},
            categoria:{},
            masonry:{},
            selectedItem: {},
            showViewer: false
        }
    },
    created(){
        this.getArtworks()
    },
    methods:{
        async getArtworks(){
            await axios.get(this.$url+'/obras-por-categoria/oil-on-linen',{
                headers: {'Content-Type' : 'application/json'}
            })
            .then((res)=>{
                this.items = res.data.items
                this.masonry = res.data.masonry
                this.categoria = { 'col_description_es': this.items[0].col_description_es, 'col_description_en': this.items[0].col_description_en }
            }).catch((err)=>{
                console.log(err)
            })
        },
        openViewer(item) {
            this.selectedItem = item
            this.showViewer = true
            document.body.style.overflow = 'hidden'
        },
        closeViewer() {
            this.showViewer = false
            this.selectedItem = null
            document.body.style.overflow = 'auto'
        }
    },
}
</script>

